import React from 'react';
import { Link } from 'react-router-dom';
import Faq from '../../components/Faq';
import Meta from '../../components/Meta';
import Marquee from 'react-fast-marquee';
import webdevelopImg from "../../assets/images/web-development-1.jpg";
import webImg2 from "../../assets/images/Types-of-Web-Development.png";
import { intellectualRelatedArticales } from '../../data/relatedArticale';

const WebDevelopment = () => {
    const faqItems = [
        {
            title: 'How long does it take to build a website?',
            content: <strong>Typically, it takes 7 to 21 days depending on the complexity of the website.</strong>
        },
        {
            title: 'Will my website be mobile responsive?',
            content: <strong>Yes, all our websites are fully responsive across all devices.</strong>
        },
        {
            title: 'Do you offer website maintenance?',
            content: <strong>Yes, we offer monthly and yearly maintenance packages.</strong>
        },
    ];

    return (
        <>
            <Meta 
                title="Web Development Service in Bangladesh | Affordable Packages" 
                description="Get responsive and high-converting websites starting from just BDT 15,000. Learn more about our web development services and packages tailored for businesses in Bangladesh."
                image={webdevelopImg}
                keywords="Web development Bangladesh, website design BDT, responsive website, custom website, SEO web development"
            />

            {/* Hero Section */}
            <div className="container-fluid py-5 bg-dark text-white">
                <div className="container py-5 text-center">
                    <h1 className="display-5 fw-bold">Professional Web Development Services</h1>
                    <p className="lead">Custom, responsive & SEO-optimized websites starting from <strong>BDT 25,000</strong></p>
                    <Link to="/contact-us" className="btn btn-warning btn-lg mt-3">Get a Free Quote</Link>
                </div>
            </div>

            {/* Why Choose Us */}
            <div className="container py-5">
                <h2 className="text-center mb-4">Why Choose Our Web Development Services?</h2>
                <div className="row text-center">
                    {[
                        "Mobile Responsive Design",
                        "SEO Optimized Structure",
                        "Lightning Fast Load Speed",
                        "Free SSL & Hosting Support",
                        "Dedicated Project Manager",
                        "Post-Launch Support & Maintenance"
                    ].map((item, idx) => (
                        <div className="col-md-4 mb-4" key={idx}>
                            <div className="p-4 shadow-sm rounded border">
                                <i className="fa fa-check-circle text-success fs-4 mb-2" />
                                <p className="fw-bold">{item}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Packages Section */}
            <div className="container py-5">
                <h2 className="text-center mb-4">Our Website Packages (In BDT)</h2>
                <div className="row text-center">
                    {[
                        {
                            name: "Starter Website",
                            price: "৳25,000",
                            features: ["Up to 5 Pages", "Responsive Design", "Contact Form", "1 Month Support"]
                        },
                        {
                            name: "Business Website",
                            price: "৳45,000",
                            features: ["Up to 10 Pages", "Dynamic Content", "WhatsApp Chat", "SEO Friendly", "3 Months Support"]
                        },
                        {
                            name: "E-Commerce Website",
                            price: "৳75,000",
                            features: ["Unlimited Products", "Payment Integration", "Admin Panel", "Training Included", "6 Months Support"]
                        },
                    ].map((pkg, idx) => (
                        <div className="col-md-4 mb-4" key={idx}>
                            <div className="card h-100 shadow-sm">
                                <div className="card-body">
                                    <h5 className="card-title">{pkg.name}</h5>
                                    <h4 className="text-primary">{pkg.price}</h4>
                                    <ul className="list-unstyled">
                                        {pkg.features.map((feature, i) => (
                                            <li key={i}><i className="fa fa-check text-success me-2" />{feature}</li>
                                        ))}
                                    </ul>
                                    <Link to="/contact-us" className="btn btn-outline-primary mt-3">Order Now</Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Development Types (reusing your content) */}
            <div className="container py-5">
                <h2 className="text-center mb-4">What We Develop</h2>
                <img className="img-fluid mb-4 mx-auto d-block" src={webImg2} alt="Web Types" />
                <ul className="list-group list-group-flush">
                    {[
                        "Front-end Websites (HTML/CSS/JS)",
                        "Back-end Web Apps (Node.js, PHP, Django)",
                        "Full-Stack Development",
                        "E-commerce Platforms",
                        "Mobile-Responsive Sites",
                        "Custom CMS Development",
                        "Portfolio & Blog Websites"
                    ].map((type, i) => (
                        <li key={i} className="list-group-item"><i className="fa fa-cogs text-primary me-2" />{type}</li>
                    ))}
                </ul>
            </div>

            {/* Related Articles */}
            <div className="container py-5 bg-light">
                <h3 className="text-center mb-3">📚 Related Articles</h3>
                <Marquee pauseOnHover>{intellectualRelatedArticales}</Marquee>
            </div>

            {/* FAQ Section */}
            <div className="container py-5">
                <h3 className="text-center mb-4">💬 Frequently Asked Questions</h3>
                <Faq items={faqItems} />
            </div>

            {/* CTA Banner */}
            <div className="container-fluid bg-primary text-white text-center py-5">
                <h2>Ready to build your dream website?</h2>
                <p className="mb-4">Let's discuss your project and turn your ideas into reality!</p>
                <Link to="/contact-us" className="btn btn-light btn-lg">Start Your Project</Link>
            </div>
        </>
    );
};

export default WebDevelopment;
